export const FILTERS = {
    ESPACES: 'espaces',
    ECO_CONCEPTION: 'eco-conception',
    CHASSE_AUX_SAVEURS: 'chasse-aux-saveurs',
};

export const FILTER_LAYER_MAP = {
    [FILTERS.ESPACES]: 'df35606b420b412c80b94bd6b3c2fe26',
    [FILTERS.ECO_CONCEPTION]: 'a9ba4152d2e196e19841bad76bc3df20',
    [FILTERS.CHASSE_AUX_SAVEURS]: '1790af16500a9167dd561d700cf6f5f3',
};
